import * as categories from './categories';

const state = {
	queue: []
};

export const triggerOrQueue = (managed, shouldQueue, args) => {
	if (categories.has(managed.category)) {
		return managed.pixel.apply(managed, args);
	}

	if (shouldQueue) {
		return add(managed, args);
	}
};

export const add = (managed, args) => {
	state.queue = [...state.queue, [managed, args]];
};

export const drain = () => {
	const prevQueue = [...state.queue];
	state.queue = [];
	prevQueue.forEach(([managed, args]) => triggerOrQueue(managed, managed.shouldQueue, args));
};
